import React, { Component } from "react";

class Account extends Component {
  render() {
    return (
      <div className="justify-content-center align-items-center row h-100">
        <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4 loginMgmt">
          <div className="card">
            <div className="card-body">
              {this.props.alertText &&
                this.props.alertText !== "" && (
                  <div className={`alert alert-${this.props.alertType}`}>
                    {this.props.alertText}
                  </div>
                )}
              {this.props.mode === "resetPassword" && (
                <form onSubmit={this.props.resetPassword}>
                  <div className="form-group">
                    <h2>Reset password</h2>
                    <label className="control-label" htmlFor="newPassword">
                      New Password
                    </label>
                    <input
                      className="form-control"
                      id="newPassword"
                      rel="newPassword"
                      type="password"
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col text-right">
                      <button className="btn btn-primary" type="submit">
                        Reset Password
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/Account.js